import React, { useRef, useEffect } from "react";
import "./MenuItem.css";

interface MenuItemProps {
  open: boolean;
  onClose: () => void;
  options: { label: string; onClick: () => void }[];
  align?: "left" | "right";
  style?: React.CSSProperties;
}

const MenuItem: React.FC<MenuItemProps> = ({
  open,
  onClose,
  options,
  align = "left",
  style,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  if (!open) return null;

  return (
    <div className={`menuitem-popup ${align}`} ref={wrapperRef} style={style}>
      {options.map((opt, idx) => (
        <div
          key={idx}
          className="menuitem-option"
          onClick={() => {
            opt.onClick();
            onClose();
          }}
        >
          {opt.label}
        </div>
      ))}
    </div>
  );
};

export default MenuItem;
